var $ = require("jquery");
var slick = require("slick-carousel");

module.exports = {
	init: function () {
		var slider = $(".slider .slider-items");
		if (slider.length > 0) {
			for (var i = 0; i < slider.length; i++) {
				// Init first slider
				$(slider[i]).slick({
					dots: false,
					infinite: false,
					arrows: true,
					speed: 300,
					slidesToShow: 1,
					slidesToScroll: 1,
					appendArrows: $(slider[i])
						.parent()
						.find(".slider-controls"),
					prevArrow:
						'<a href="javascript:;"><span class="visually-hidden">Previous Slide</span> <span class="slider-prev-arrow"></span></a>',
					nextArrow:
						'<a href="javascript:;"><span class="visually-hidden">Next Slide</span> <span class="slider-next-arrow"></span></a>',
				});
			}
		}

		// var sliderWithNav = $('.slider .slider__wrapper');
		// if (sliderWithNav.length > 2) {
		//     for (var i = 0; i < sliderWithNav.length; i++) {
		//         var main = $(sliderWithNav[i]).find('.items');
		//         var nav = $(sliderWithNav[i]).find('.items-nav');

		//         window.addEventListener('load', function () {
		//             if ( window.innerWidth < 768 ) {
		//                 // Init first slider
		//                 $(main).slick();
		//             } else if ( window.innerWidth > 768 ) {
		//                 // Init first slider
		//                 $(main).slick();
		//                 // Init nav slider
		//                 $(nav).slick();
		//             }
		//         });
		//         window.addEventListener('resize', function() {
		//             if ( window.innerWidth < 768 && $(nav).hasClass('slick-initialized') ) {
		//                 $(nav).slick('unslick');
		//             } else if ( window.innerWidth > 768 && !$(nav).hasClass('slick-initialized') ) {
		//                 $(nav).slick();
		//             }
		//         });

		//     }
		// }
	},
};
